import React, { useState } from "react";
import { Tag, Modal, Timeline, Input } from "antd";
import DataTable from '@/components/DataTable';
import MainCard from '@/components/MainCard';
import ReusableSearchInput from '@/components/ReusableSearch';
import { useMbmrAlias } from '@/hooks/useAppSetting';
const DispatchHistory = () => {
  const mbmrAlias = useMbmrAlias();
  const [visible, setVisible] = useState(false);
  const [workflowData, setWorkflowData] = useState([]);
  const [searchText, setSearchText] = useState("");

  const statusColors = {
    "Ready for Dispatch": "blue",
    Dispatched: "cyan",
    Delivered: "green",
  };

  const dispatchData = [
    {
      key: "1",
      batchId: "B1001",
      product: "Paracetamol",
      createdDate: "2024-03-28",
      status: "Ready for Dispatch",
      workflow: [
        {
          step: "Quality Check Completed",
          time: "2024-03-28 10:00 AM",
          completed: true,
        },
        {
          step: "Packaging Completed",
          time: "2024-03-28 12:00 PM",
          completed: true,
        },
        {
          step: "Awaiting Dispatch",
          time: "2024-03-28 02:00 PM",
          completed: false,
        },
      ],
    },
    {
      key: "2",
      batchId: "B1002",
      product: "Ibuprofen",
      createdDate: "2024-03-28",
      status: "Dispatched",
      workflow: [
        {
          step: "Quality Check Completed",
          time: "2024-03-27 09:00 AM",
          completed: true,
        },
        {
          step: "Packaging Completed",
          time: "2024-03-27 11:00 AM",
          completed: true,
        },
        { step: "Dispatched", time: "2024-03-27 04:00 PM", completed: true },
      ],
    },
    {
      key: "3",
      batchId: "B1003",
      product: "Aspirin",
      createdDate: "2024-03-28",
      status: "Dispatched",
      workflow: [
        {
          step: "Quality Check Completed",
          time: "2024-03-26 08:00 AM",
          completed: true,
        },
        {
          step: "Packaging Completed",
          time: "2024-03-26 10:00 AM",
          completed: true,
        },
        { step: "Dispatched", time: "2024-03-26 02:00 PM", completed: true },
        { step: "Delivered", time: "2024-03-27 09:00 AM", completed: true },
      ],
    },
  ];

  const handleStatusClick = (workflow) => {
    setWorkflowData(workflow);
    setVisible(true);
  };

  const filteredData = dispatchData.filter(
    (item) =>
      item.batchId.toLowerCase().includes(searchText.toLowerCase()) ||
      item.product.toLowerCase().includes(searchText.toLowerCase())
  );

  const columns = [
    { title: `${mbmrAlias} Batch No.`, dataIndex: "batchId", key: "batchId" },
    { title: "Product", dataIndex: "product", key: "product" },
    { title: "Created Date", dataIndex: "createdDate", key: "createdDate" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status, record) => (
        <Tag
          color={statusColors[status]}
          onClick={() => handleStatusClick(record.workflow)}
          style={{ cursor: "pointer" }}
        >
          {status}
        </Tag>
      ),
    },
  ];

  return (
    <MainCard title="Dispatch Logs">
      <div style={{ display: "flex", justifyContent: "end", marginBottom: 2 ,marginTop:-40}}>
        <Input.Search
          placeholder="Search by Batch ID or Product"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          style={{ width: 250 }}
        />

                <ReusableSearchInput
                  placeholder="Search here..."
                  width={250}
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
      </div>
      <DataTable
        columns={columns}
        data={filteredData}
        pagination={{ pageSize: 5 }}
        bordered
        height={null}
      />
      <Modal
        title="Dispatch Workflow"
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Timeline>
          {workflowData.map((item, index) => (
            <Timeline.Item
              key={index}
              color={item.completed ? "green" : "gray"}
            >
              {item.time} - {item.step}
            </Timeline.Item>
          ))}
        </Timeline>
      </Modal>
    </MainCard>
  );
};

export default DispatchHistory;
